import { render, staticRenderFns } from "./medicalBillingTest.vue?vue&type=template&id=29ef4185&scoped=true&"
import script from "./medicalBillingTest.vue?vue&type=script&lang=js&"
export * from "./medicalBillingTest.vue?vue&type=script&lang=js&"
import style0 from "./medicalBillingTest.vue?vue&type=style&index=0&id=29ef4185&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ef4185",
  null
  
)

export default component.exports